export default "__VITE_ASSET__Cw4kM5th__"